export const sendDataToReactNative = (value) => {
  if(window.ReactNativeWebView?.postMessage) {
    window.ReactNativeWebView.postMessage(value)
  }
}